import React from 'react';
import { SafeImg } from '../../SafeImg';
import { Btn, H1, Eyebrow, tidFor, E } from './_shared';

/* ════════════════════════════════════════════════════════════════════════
 * NEW BLOCK TYPE — cart_table (line items)
 *
 * Iter 175c — Section Audit. title and per-item name/variant inline-
 * editable. Subtotal/total are computed (intentionally non-editable).
 * ════════════════════════════════════════════════════════════════════════ */
export function CartTableBlock({ block, theme, E: EProps = {} }) {
  const { onEdit } = EProps;
  const c = block.content || {};
  const items = c.items || c.lines || [
    { name:'Sample Item 1', price:29.99, qty:1, image:null },
    { name:'Sample Item 2', price:49.99, qty:2, image:null },
  ];
  const subtotal = items.reduce((acc,it)=>acc + (Number(it.price)||0) * (Number(it.qty)||1), 0);
  const ctaLabel = c.cta_label || 'Checkout';

  return (
    <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-12" style={{ background: theme.bg, color: theme.ink }}>
      <div className="max-w-4xl mx-auto">
        <E block={block} onEdit={onEdit} field="title" value={c.title || 'Your Cart'} tag="h2" className="text-2xl md:text-3xl font-bold mb-8" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
        <div className="space-y-4">
          {items.map((it,i)=>(
            <div key={i} className="grid grid-cols-12 gap-4 items-center py-4 border-b border-gray-100">
              <div className="col-span-2 aspect-square bg-gray-100">{it.image && <SafeImg src={it.image} alt={it.name} className="w-full h-full object-cover" />}</div>
              <div className="col-span-5">
                <E block={block} onEdit={onEdit} field={`items.${i}.name`} value={it.name} tag="p" className="font-bold text-sm" placeholder="Item name" />
                <E block={block} onEdit={onEdit} field={`items.${i}.variant`} value={it.variant || ''} tag="p" className="text-xs opacity-60 mt-1" placeholder="Variant" />
              </div>
              <div className="col-span-2 flex items-center gap-2 text-sm">
                <button className="w-7 h-7 border border-gray-300 rounded">−</button>
                <span className="w-6 text-center">{it.qty}</span>
                <button className="w-7 h-7 border border-gray-300 rounded">+</button>
              </div>
              <div className="col-span-2 text-right font-bold text-sm">${((Number(it.price)||0)*(Number(it.qty)||1)).toFixed(2)}</div>
              <button className="col-span-1 text-xs opacity-40 hover:opacity-80">✕</button>
            </div>
          ))}
        </div>
        <div className="mt-8 flex justify-end">
          <div className="w-full md:w-80">
            <div className="flex justify-between py-2 border-b border-gray-100"><span className="opacity-70 text-sm">Subtotal</span><span className="font-bold">${subtotal.toFixed(2)}</span></div>
            <div className="flex justify-between py-2 text-lg font-bold"><span>Total</span><span style={{ color: theme.accent }}>${subtotal.toFixed(2)}</span></div>
            <span className="mt-4 w-full block py-3 rounded-full text-sm font-bold uppercase tracking-wider text-white text-center cursor-text" style={{ background: theme.accent || '#7C3AED' }}>
              <E block={block} onEdit={onEdit} field="cta_label" value={ctaLabel} tag="span" placeholder="Checkout" />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
